import { Projects } from "./components/Projects";
import { SearchField } from "../components";
import { useSearchParams } from "react-router-dom";

export function ProjectList() {
  const [searchParams] = useSearchParams();
  const searchString = searchParams.get("search") ?? undefined;

  return (
    <>
      <h3 className="mb-2">Projects</h3>
      <div className="mb-3">
        <SearchField />
      </div>

      <Projects filters={{ searchString }} expanded={true} allowExpand={false} />
    </>
  );
}
